export const APP_LANGUAGE_STORAGE_KEY = 'app_language';

export type AppLanguage = 'en' | 'pl';

/**
 * Initial UI language:
 * 1. `localStorage` (`app_language`) when the user already chose a language.
 * 2. `navigator.languages` / `navigator.language`: any tag with `pl` prefix → Polish; otherwise English.
 */
export function resolveInitialAppLanguage(): AppLanguage {
  try {
    const stored = localStorage.getItem(APP_LANGUAGE_STORAGE_KEY);
    if (stored === 'en' || stored === 'pl') return stored;
  } catch {
    /* ignore */
  }
  try {
    const candidates = [...(navigator.languages ?? []), navigator.language].filter(Boolean) as string[];
    for (const raw of candidates) {
      const nav = raw.toLowerCase();
      if (nav.startsWith('pl')) return 'pl';
    }
  } catch {
    /* ignore */
  }
  return 'en';
}

export function appLanguageToHtmlLang(lang: AppLanguage): 'en' | 'pl' {
  return lang === 'pl' ? 'pl' : 'en';
}
